<script>
    import { default as polygonAttributes } from '../notebooks/polygon-attributes'
    import { areaAggregateQuery, geoFeatureArea, requestCache, geoFeature } from './area-reports/requests'
    import { onMount, createEventDispatcher } from 'svelte';
    import EditableReport from './EditableReport.svelte'
    import {areaReportTopics} from "./area-reports/area-report-topics";
    import {writable} from "svelte/store";
    import { ol, proj4 } from './mapping/ol';


    export let report;
    export let reportLink = '';
    export let editing = false;
    export let areaAggregateQueryFn = areaAggregateQuery;
    export let geoFeatureAreaFn = geoFeatureArea;
    export let geoFeatureFn = geoFeature;
    export let editable = false;

    let cacheCleared = false;

    const dispatch = createEventDispatcher();

    let geoFeatureReport = writable(undefined);

    $: if (report) {
        geoFeatureReport.set(geoFeatureFn(report).request);
    }

    onMount(() => {
        requestCache.clear();
        cacheCleared = true;
    });

    $: header = {
        showHeader: false,
        extraClass: 'polygon-header report-header-topic',
        sections: [
            {
                notebookViews: [
                    {
                        notebook: polygonAttributes,
                        cells: ['report', 'viewof map', 'mapLoaded'],
                        overrides: new Map([
                            ['polygonSubject', $geoFeatureReport],
                            ['areaResponse', geoFeatureAreaFn(report).request],
                            ['olModules', ol],
                            ['css', undefined],
                            ...proj4(),
                            ['dataUrl', undefined]
                        ])
                    }
                ]
            }
        ]
    };

    $: categories = areaReportTopics(report, areaAggregateQueryFn);

    let rootElement;
    let topicState = report && report.topics || {};

    function onReportUpdated (event) {
        report = {
            ...report,
            ...event.detail
        };

        if (event.detail && event.detail.topics) {
            topicState = event.detail.topics;
        }

        dispatch('reportUpdated', report);
    }
</script>

<style>
    :global(.report-header-topic .frag-notebook) {
        display: flex;
    }

    :global(.report-header-topic [data-cell=report]) {
        flex: 1;
    }

    :global(.report-header-topic [data-cell=report]) {
        width: auto;
    }

    :global(.report-header-topic [data-cell=mapLoaded]) {
        display: none;
    }
    
    @media print {
        :global(.oe-area-report .lower-controls) {
            display: none;
        }
        /*:global(text) {
            display: none;
        }*/
    }
</style>

<EditableReport extraClass="oe-area-report" {editable} {report} {reportLink} {editing} {header} {categories} {topicState} reportKind="Area report" iconClass="icon icon-area" on:reportUpdated={onReportUpdated}></EditableReport>
